import { DioramaProvider } from "./contexts/DioramaContext";
import DioramaWizard from "./components/wizard/DioramaWizard";

function App() {
	return (
		<div className="App">
			<DioramaProvider>
				<DioramaWizard />
			</DioramaProvider>
		</div>
	);
}

export default App;
